import React from 'react';
import PixM from './babaunited.jpg';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-section">
        <h5 className="about-heading">Mission</h5>
        <p className="about-text">To bring awareness to public education issues in Nigeria through giving back to one's alma mater - 
          United Methodist Grammar School, Ilesa, Osun State, Nigeria. We plan to do this
          in form of rebuilding, rewarding students & teachers, providing resources, sponsoring higher
          education, and connecting them with the future. By this, we plan to showcase what a united minds can
          achieve, and to encourage others to do the same, thus, lifting Nigeria public education standards.
        </p>
      </div>

      <div className="about-section">
        <h5 className="about-heading">Goal</h5>
        <p className="about-text">Giving back to a place that laid the foundation for one's life is Noblesse Oblige!</p>
      </div>

      <div className="about-section">
        <div>
          <img className="images" src={PixM} alt="Baba United statue" />
        </div>
        <h5 className="about-heading">Do you really know the story behind this statue called Baba United?</h5>
        <p className="about-text">Well, let me tell you the story. When the United 95 set were in JSS 2, the fine-art teacher, Mr. Ojo asked us to make items such as plates, cups e.t.c. as homework, 
          having taught us how to do the same in class with Paper-Mache (starch and paper mixed together with water). He was so impressed with our homework 
          that he suggested we should do something big as a monument for the school - thus this statue idea came up.
          You may not even be aware of this, the current statue you see today was not the original one. The first one we built, was made out of clothing hangers as skeletons, 
          and the Paper-Mache, then, painted beautifully. No one would have guessed the inferiority of the materials used, until one faithful day when it rained heavily. 
          We came back to school the following day to find our precious statue on the ground - the wind had knocked it down to the ground.
          Sad and disappointed, the school rallied around us to raised funds, which we used to construct a new, 
          iron skeleton statue with the help of a local welder, and Mr. Ojo carefully plastered it with cement. 
          He had one of us Obembe, Gbenga (of a blessed memory) to pose as the image while he carefully modeled it. As you can see, the final product is still standing as of today.
        </p>
      </div>
    </div>
  );
};

export default About;
